import { useContext } from 'react'

/**
 * Custom hook that returns a function to mark store for refresh
 * @param {React.Context} storeContext - Context of the store
 * @returns {Function} - Function to mark store as needing refresh
 */
export function useMarkForRefresh(storeContext) {
  const store = useContext(storeContext)
  
  return () => {
    store.needsRefresh = true
  }
}

